import React from "react";
import { Link } from "react-router-dom";
import Project from "../../../api/project";
import Bg from "../../../images/backgrounds/bg_image_2.webp";
import Bg2 from "../../../images/shapes/shape_bg_1.webp";
import Bg3 from "../../../images/shapes/shape_title_under_line.svg";
import about1 from "../../../images/about/ABOUT_US.webp";
import aIcon1 from "../../../images/avatar/avatar_1.webp";
import aIcon2 from "../../../images/avatar/avatar_2.webp";
import aIcon3 from "../../../images/avatar/avatar_3.webp";
import aIcon4 from "../../../images/icons/icon_global.svg";
import aIcon5 from "../../../images/shapes/shape_line.webp";
import shape1 from "../../../images/shapes/shape_space_2.svg";

const About = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <section
      className="about_and_case_section section_space section_decoration bg-dark"
      style={{ backgroundImage: `url(${Bg})` }}
    >
      <div className="container">
        <div className="row align-items-center justify-content-lg-between">
          <div className="col-lg-7 order-lg-last">
            <div className="about_image_2">
              <div className="image_wrap">
                <img src={about1} alt="UFS - About" />
              </div>

              <div
                className="about_funfact_info"
                style={{ backgroundImage: `url(${Bg2})` }}
              >
                <div className="customer_count">
                  <ul className="unordered_list pe-4">
                    <li>
                      <img src={aIcon1} alt="Customer Avatar" />
                    </li>
                    <li>
                      <img src={aIcon2} alt="Customer Avatar" />
                    </li>
                    <li>
                      <img src={aIcon3} alt="Customer Avatar" />
                    </li>
                    <li>
                      <span>6k+</span>
                    </li>
                  </ul>
                  <p className="mb-0">Happy Customer</p>
                </div>
                
                <div className="about_funfact_counter">
                  <div className="funfact_item ps-3">
                    <div className="counter_value">
                      <span className="odometer" data-count="6">
                        5
                      </span>
                      <span>K+</span>
                    </div>
                    <h3 className="funfact_title mb-0">Projects Done</h3>
                  </div>
                  <div className="funfact_item">
                    <div className="counter_value">
                      <span className="odometer" data-count="100">
                        99.9
                      </span>
                      <span>%</span>
                    </div>
                    <h3 className="funfact_title mb-0">Results Guaranteed</h3>
                  </div>
                </div>

                <a className="btn btn-primary" href="about">
                  <span className="btn_label" data-text="Learn More">
                    Learn More
                  </span>
                  <span className="btn_icon">
                    <i className="fa-solid fa-arrow-up-right"></i>
                  </span>
                </a>
                <div className="icon_globe">
                  <img src={aIcon4} alt="Icon Globe" />
                </div>
              </div>

              <div className="space_line">
                <img src={aIcon5} alt="Shape Line" />
              </div>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="about_content">
              <div className="heading_block mb-0 text-white">
                <div
                  className="heading_focus_text has_underline d-inline-flex"
                  style={{ backgroundImage: `url(${Bg3})` }}
                >
                  About Us
                </div>
                <h2 className="heading_text">
                  UFS <mark>Mission & Goal</mark>
                </h2>
               
                <p className="heading_description mb-0" style={{ textAlign: 'justify' }}>
                  UFS Networks partners with global enterprises, SMEs, and tech
                  leaders to enhance business value through custom software
                  development, expert consultancy, and professional services. We
                  optimize and modernize IT infrastructure, offer Cloud
                  solutions, and tackle diverse infrastructure challenges.
                </p>
                <a className="btn btn-primary mt-4" href="contact">
                  <span className="btn_label" data-text="Contact us">
                    Contact us
                  </span>
                  <span className="btn_icon">
                    <i className="fa-solid fa-arrow-up-right"></i>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-170">
          <div className="heading_block text-center text-white">
            <div
              className="heading_focus_text has_underline d-inline-flex"
              style={{ backgroundImage: `url(${Bg3})` }}
            >
              Case Studies
            </div>
            <h2 className="heading_text mb-0">
              Our latest <mark>Case</mark> Studies
            </h2>
          </div>

          <div className="case_studies_wrapper">
            {Project.slice(6, 9).map((project, prj) => (
              <div className="case_study_block" key={prj}>
                <div className="case_study_image">
                  <img src={project.pImg} alt="UFS - Cases" />
                </div>
                <div className="case_study_content">
                  <ul className="category_list unordered_list text-uppercase">
                    <li>
                      <a href="portfolio.html">{project.title}</a>
                    </li>
                  </ul>
                  <h3 className="case_title">
                    <Link
                      onClick={ClickHandler}
                      to={`/portfolio_details/${project.slug}`} 
                    >
                      {project.sub}
                    </Link>
                  </h3>
                  
                  <p style={{ textAlign: 'justify' }}> {project.description}</p>
                  {/* <p> </p> */}
                  <ul className="icon_list unordered_list">
                    <li>
                      <span className="icon_list_text">
                        <strong className="text-dark">Industry:</strong>{" "}
                        {project.Industry}
                      </span>
                    </li>
                    <li>
                      <span className="icon_list_text">
                        <strong className="text-dark">Country:</strong>{" "}
                        {project.Country}
                      </span>
                    </li>
                  </ul>
                  <ul
                    className="case_technologies unordered_list"
                    data-text="Core Technologies:"
                  >
                    <li>
                      <img src={project.Technologies1} alt="Angular" />
                    </li>
                    <li>
                      <img src={project.Technologies2} alt="Elephent" />
                    </li>
                  </ul>
                  {/* <div style={{ display: 'flex', alignItems: 'center' }}> */}
                  <Link
                    onClick={ClickHandler}
                    to={`/portfolio_details/${project.slug}`}
                    className="btn btn-primary"
                  >
                    <span className="btn_label" data-text="Read Case">
                      Read Case
                    </span>
                    <span className="btn_icon">
                      <i className="fa-solid fa-arrow-up-right"></i>
                    </span>
                  </Link>
                  {/* <a href="https://example.com"
                   target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-secondary"
                    style={{ marginLeft: '10px' }}
                  >
                    <span className="btn_label" data-text="View">
                      View
                   </span>
                   <span className="btn_icon">
                      <i className="fa-solid fa-eye"></i>
                  </span>
                  </a>
                 </div> */}
                  <div>
                </div>
                </div>
              </div>
            ))}
          </div>

          <div className="btns_group pb-0">
            <Link
              onClick={ClickHandler}
              to="/portfolio"
              className="btn btn-primary"
            >
              <span className="btn_label" data-text="View More Cases Study">
                View More Cases Study
              </span>
              <span className="btn_icon">
                <i className="fa-solid fa-arrow-up-right"></i>
              </span>
            </Link>
          </div>
        </div>
      </div>
      <div className="decoration_item shape_image_1">
        <img src={shape1} alt="Techco Shape" />
      </div>
    </section>
  );
};

export default About;
